import React, { Component } from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'
import logo from '../../assets/images/logo-starship.png'
import { SearchBar } from './search'
import { SearchHelper } from '../../helpers'
import { SECTIONS } from './../../utils/url'

export default class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showMenu: false,
            isSearchActive: false,
            isMobileMenuOpen: false,
        }
    }

    toggleMobileMenu = () => {
        this.setState((prevState) => ({
            isMobileMenuOpen: !prevState.isMobileMenuOpen,
        }))
    }

    openSearch = () => this.setState({ isSearchActive: true, isMobileMenuOpen: false })
    closeSearch = () => this.setState({ isSearchActive: false })

    componentDidMount() {
        SearchHelper.saveUTMParams(window.location.search)
    }

    render() {
        const { openClass, activeSection, inferSearchSection } = this.props
        const { showMenu, isSearchActive } = this.state

        // Get current section name...
        const SECTIONS_ARRAY = Object.values(SECTIONS)
        const section = SECTIONS_ARRAY.find((section) => section.key === activeSection)
        const sectionName = section && section.name
        const environment = process.env.GATSBY_CONTENTFUL_ENVIRONMENT || 'master';
        const bookmarks = (typeof window !== 'undefined' && JSON.parse(localStorage.getItem('bookmarks'))) || []

        return (
            <header className={classNames('app-header', { [openClass]: openClass })}>
                
                   <div className={classNames("heading", { 'has-sticky-banner': environment !== 'master' })}>
                    <div className="mobile-header-links">
                        <button className="mobile-menu-toggle" onClick={this.toggleMobileMenu}>
                            <i className={`far ${this.state.isMobileMenuOpen ? 'fa-times' : 'fa-bars'} mobile-menu-toggle-icon`} />
                        </button>
                    </div>
                    <Link to="/" id="mobile-logo">
                        <img src={logo} alt="Starship Logo" title="Starship Logo" />
                    </Link>
                    <div className="header-links">
                        <Link to="/health-professionals/work-at-starship">Work at Starship</Link>
                        <Link to="/contact-us">Contact</Link>
                        {SECTIONS.HEALTH_PROFESSIONALS.key === activeSection && (
                            <Link className={bookmarks.length > 0 ? 'shortlist-not-empty' : 'shortlist-empty'} to="/guidelines/my-shortlist">
                                My Shortlist {bookmarks.length > 0 && <i className="fas fa-bookmark" />}
                            </Link>
                        )}
                    </div>

                    <div className="header-links-right">
                        <div id="header-searchbar-wrapper" className={isSearchActive ? 'active' : ''}>
                            <SearchBar id={'header-searchbar'} activeSection={inferSearchSection && activeSection} openSearch={() => this.openSearch()} closeSearch={() => this.closeSearch()} />
                        </div>
                        {SECTIONS.HEALTH_PROFESSIONALS.key === activeSection && (
                            <Link to="/guidelines/my-shortlist" className="shortlist-btn">
                                <i className="fas fa-star icon" />
                            </Link>
                        )}

                        <a href="https://starship-foundation-donate.raiselysite.com/" rel="noopener noreferrer" target="_blank" className="donate-btn">
                            <i className="far fa-heart icon" />
                            <span>Donate</span>
                        </a>
                    </div>
                </div>

                {/* Mobile Navigation */}
                <div role="navigation" aria-label="Principale navigation mobile " className={`navbar-wrapper-mobile ${this.state.isMobileMenuOpen ? 'active' : ''}`}>
                    <div className="navbar-mobile">
                        <ul className="nav-menu-mobile">
                            <li className={classNames({ highlight: activeSection === SECTIONS.VISITOR.key })}>
                                <Link to={SECTIONS.VISITOR.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.VISITOR.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.HEALTH_PROFESSIONALS.key })}>
                                <Link to={SECTIONS.HEALTH_PROFESSIONALS.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.HEALTH_PROFESSIONALS.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.SUPPORT_STARSHIP.key })}>
                                <Link to={SECTIONS.SUPPORT_STARSHIP.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.SUPPORT_STARSHIP.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.SAFEKIDS.key })}>
                                <Link to={SECTIONS.SAFEKIDS.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.SAFEKIDS.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.POWER_TO_PROTECT.key })}>
                                <Link to={SECTIONS.POWER_TO_PROTECT.url} onClick={this.toggleMobileMenu}>
                                    {SECTIONS.POWER_TO_PROTECT.name}
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us" onClick={this.toggleMobileMenu}>
                                    Contacts
                                </Link>
                            </li>
                            <li>
                                {SECTIONS.HEALTH_PROFESSIONALS.key === activeSection && (
                                    <Link to="/guidelines/my-shortlist" className={bookmarks.length > 0 ? 'shortlist-not-empty' : 'shortlist-empty'} onClick={this.toggleMobileMenu}>
                                        My Shortlist {bookmarks.length > 0 && <i className="fas fa-bookmark" />}
                                    </Link>
                                )}
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Desktop Navigation */}
                <div className={'navbar-wrapper'}>
                    <Link to="/" id="logo">
                        <img src={logo} alt="Starship Logo" title="Starship Logo" />
                    </Link>
                    <div className={'navbar'}>
                        <div className="nav-active-menu-item" onClick={() => this.toggleMenu()}>
                            {sectionName}
                        </div>
                        <ul className={`nav-menu ${showMenu ? 'active' : ''}`}>
                            <li className={classNames({ highlight: activeSection === SECTIONS.VISITOR.key })}>
                                <Link to={SECTIONS.VISITOR.url}>
                                    {SECTIONS.VISITOR.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.HEALTH_PROFESSIONALS.key })}>
                                <Link to={SECTIONS.HEALTH_PROFESSIONALS.url}>
                                    {SECTIONS.HEALTH_PROFESSIONALS.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.SUPPORT_STARSHIP.key })}>
                                <Link to={SECTIONS.SUPPORT_STARSHIP.url}>
                                    {SECTIONS.SUPPORT_STARSHIP.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.SAFEKIDS.key })}>
                                <Link to={SECTIONS.SAFEKIDS.url}>
                                    {SECTIONS.SAFEKIDS.name}
                                </Link>
                            </li>
                            <li className={classNames({ highlight: activeSection === SECTIONS.POWER_TO_PROTECT.key })}>
                                <Link to={SECTIONS.POWER_TO_PROTECT.url}>
                                    {SECTIONS.POWER_TO_PROTECT.name}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        )
    }

    toggleMenu = () => {
        this.setState({
            showMenu: !this.state.showMenu,
        })
    }
}

Header.defaultProps = {
    inferSearchSection: true,
}
